import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SearchBar = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (onSearch) {
      onSearch(value);
    }
  };

  return (
    <div className="w-full px-4 md:px-6 lg:px-8 mb-2">
     
      <div className="max-w-4xl mx-auto">

        <div  className="relative w-full">
          <input
            type="text"
            value={searchQuery}
            onChange={handleChange}
            placeholder="عما تبحث ؟"
            className="w-full font-[cairo] h-8 md:h-12 bg-white rounded-[30px] px-4 md:px-5 pr-12 md:pr-14 text-sm md:text-base text-foreground placeholder:text-muted-foreground outline-none border-0  focus:ring-2 focus:ring-primary transition-all duration-250"
            aria-label="البحث عن مطعم أو طبق"
          />

          {/* أيقونة البحث */}
          <div className="absolute inset-y-0 right-4 md:right-5 flex items-center pointer-events-none">
            <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
          </div>
        </div>

      </div>
    </div>
  );
};

export default SearchBar;